import React from 'react';
import PropTypes from 'prop-types';

import { MapMarkerAltSolidIcon } from '../../../shared/icons/icons';

import styles from './my-store-map-marker.scss';

function MyStoreMapMarker(props) {
  const { onClick } = props;

  return <MapMarkerAltSolidIcon className={styles['icon']} onClick={onClick} />;
}

MyStoreMapMarker.propTypes = {
  onClick: PropTypes.func
};

export default React.memo(MyStoreMapMarker);
